import React, {useEffect, useRef, useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import LoginUserModal from "../LoginUserModal";
import {ReactComponent as BogoIco} from "../../../../images/icons/bogo-outline.svg";
import UserContextOld from "../../../services/User/UserContextOld";
import {RootState} from "../../../../reducers";
import {getUser} from "../../../services/User/reducer";
import UserUtils from "../../../services/User/UserUtils";
import {getStoreConfigLoyalty} from "../../../services/Store/reducer";


type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

function AdvertUserComponent(props: Props) {
    const [loginModal, setLoginModal] = useState(false);
    const {t} = useTranslation();
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!ref.current) return;

        const targets = [
            ...document.querySelectorAll<HTMLElement>(".cart-sticky, .main-content"),
        ];

        const setMargins = (visible: boolean) => {
            const height = ref.current?.offsetHeight || 0;
            targets.forEach((el) => {
                el.style.marginTop = visible ? `${height}px` : "";
                el.style.paddingTop = !visible && !el.classList.contains('cart-sticky') ? `${height}px` : "";
            });
        };

        const rect = ref.current.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < window.innerHeight;
        setMargins(visible);

        const intersectionObserver = new IntersectionObserver(
            ([entry]) => setMargins(entry.isIntersecting),
            {threshold: 0}
        );
        intersectionObserver.observe(ref.current);

        const resizeObserver = new ResizeObserver(() => {
            const rect = ref.current?.getBoundingClientRect();
            const isVisible = rect && rect.bottom > 0 && rect.top < window.innerHeight;
            setMargins(!!isVisible);
        });
        resizeObserver.observe(ref.current);

        return () => {
            intersectionObserver.disconnect();
            resizeObserver.disconnect();
            targets.forEach((el) => {
                el.style.marginTop = "";
                el.style.paddingTop = "";
            });
        };
    }, []);

    if (props.user && props.user.name) return null;
    if (UserContextOld.getToken()) return null;
    if (!UserUtils.isLoyaltyRegistration(props.config_loyalty)) return null;

    return (
        <>
            {loginModal && (
                <LoginUserModal page={"REGISTER"} onHide={() => setLoginModal(false)} show/>
            )}
            <div className="promo-top-banner" ref={ref}>
                <div className="d-flex gap-3 align-items-center">
                    <BogoIco/>
                    <p className="mb-0">
                        {props.config_loyalty?.registration?.banner_text ? (
                            props.config_loyalty?.registration?.banner_text
                        ) : (
                            <>
                                {t("modules.user.field.create_an_account.title")}
                                <strong>{t("modules.user.field.unique_offers.title")}</strong>
                                {t("modules.user.field.for_registered_users.title")}
                            </>
                        )}
                    </p>
                </div>
                <a href={"#"} className={"btn btn-primary stretched-link"} onClick={(e) => {
                    e.preventDefault();
                    setLoginModal(true)
                }}>
                    {t("common.action.create_an_account")}
                </a>
            </div>
        </>
    )
}


const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    config_loyalty: getStoreConfigLoyalty(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(AdvertUserComponent));